import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { forwardRef } from "react";
import { useParams } from "react-router-dom";
import Loading from "../shared/Loading";
import patientService from "../services/patient.service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./invoice.module.css";
import Address from "../shared/Address";
import GstSummary from "../hospital/GstSummary";
import { DateFormat } from "../Helper";
import CollectionSummary from "./CollectionSummary";
import ClientSummary from "./ClientSummary";
import OrderSummary from "./OrderSummary";
// var inv;
const InvoiceComponent = forwardRef(function InvoiceComponent({}, ref) {
  console.log("Invoice loaded");
  const [isLoading, setIsLoading] = useState(true);
  const { patientId, invoiceId } = useParams();
  const [inv, setInv] = useState();
  // var inv;
  const fetchData = async () => {
    try {
      const invoice = await patientService.getInvoice(patientId, invoiceId);
      setInv(invoice);
      setIsLoading(false);
    } catch (error) {
      setIsLoading("error");
      console.log(error);
    }
  };
  useEffect(() => {
    setIsLoading(true);
    fetchData();
    return () => {
      setIsLoading(false);
    };
  }, []);

  if (isLoading === true) {
    return <Loading />;
  } else if (isLoading === "error") {
    return <Loading failed={true} />;
  }
  const { bp, invoice, user } = { ...inv };
  return (
    <div className="container-fluid invoice-container">
      <h4 className="text-center">Tax Invoice</h4>
      <div className="page-header my-3">
        <ClientSummary {...inv} />

        <OrderSummary summary={invoice} />
      </div>
      <div className="away-from-header">
        <div className="py-2 order-details">
          <h5 className="font-size-15">Order Details</h5>
          <hr className="my-2" />

          <div className="table-responsive">
            <table
              className="table align-middle table-nowrap table-centered mb-0"
              style={{ fontSize: "12px" }}
            >
              <colgroup>
                <col style={{ width: "70px" }} />
                <col
                  style={{ width: "13%", textAlign: "right" }}
                  className="text-end"
                />
                <col
                  style={{
                    width: "13%",
                    textAlign: "right",
                    fontSize: "14px",
                  }}
                />
                <col style={{ width: "13%", textAlign: "right" }} />
                <col style={{ width: "13%", textAlign: "right" }} />
                <col style={{ width: "13%", textAlign: "right" }} />
                <col style={{ width: "13%", textAlign: "right" }} />
                <col style={{ width: "13%", textAlign: "right" }} />
              </colgroup>
              <thead>
                <tr>
                  <th style={{ width: "70px" }}>No.</th>
                  <th>Item</th>
                  <th>Base Price</th>
                  <th>Quantity</th>
                  <th>Discount</th>
                  <th>Taxable</th>

                  {/* <th>GST</th> */}
                  {invoice.order_items[0].gst_breakup.map((gst, index) => (
                    <th
                      key={index}
                      className="text-uppercase"
                    >{`${gst.type}`}</th>
                  ))}
                  <th>Subtotal</th>
                </tr>
              </thead>

              <tbody>
                {invoice.order_items.map((item, index) => (
                  <tr
                    key={item.bp_service_order_item_id}
                    className="font-size-10"
                  >
                    <th scope="row">{index + 1}</th>
                    <td>
                      <div>
                        <strong className="text-truncate font-size-14 mb-1">
                          {item.item_service_details.bp_service_name}
                        </strong>
                        {/* <p className="text-muted mb-0">Watch, Black</p> */}
                      </div>
                    </td>
                    <td>{item.item_base_price}</td>
                    <td>{item.item_quantity}</td>
                    <td>{item.item_discount_amount}</td>
                    <td>{item.taxable_amount}</td>

                    {item.gst_breakup.map((gst, index) => (
                      <td key={index}>{`${gst.amount} (${gst.percentage})`}</td>
                    ))}

                    <td className="text-end">{item.subtotal}</td>
                  </tr>
                ))}

                <tr>
                  <td rowSpan={3} colSpan={6}></td>
                  <th scope="row" colSpan="2" className="text-end">
                    Sub Total
                  </th>
                  <td className="text-end">{invoice.grand_total}</td>
                </tr>

                <tr>
                  <th scope="row" colSpan="2" className="text-end">
                    Disocunt
                  </th>
                  <td className="text-end">- {invoice.other_discounts}</td>
                </tr>

                <tr>
                  <th scope="row" colSpan="2" className="text-end">
                    Service & Other Charges
                  </th>
                  <td className="text-end">{invoice.other_charges}</td>
                </tr>

                <tr>
                  <td colSpan={6}>
                    Amount in words:{" "}
                    <strong className="text-capitalize">
                      {invoice.total_in_words} rupees
                    </strong>
                  </td>
                  <th scope="row" colSpan="2" className="text-end">
                    Total
                  </th>
                  <td className="text-end">
                    <h4 className="m-0 fw-semibold">{invoice.grand_total}</h4>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <Row className="mt-3">
            <Col xs={6}>
              <GstSummary items={invoice.order_items} />
            </Col>
          </Row>
        </div>
        <div className="py-2 payment-details print-page-break">
          <CollectionSummary collections={invoice.collections} />
        </div>
      </div>
      <div className="d-print-none my-4 text-end">
        <button
          onClick={() => {
            window.print();
          }}
          className="btn btn-success me-1"
          type="button"
        >
          <FontAwesomeIcon icon="fa-solid fa-print" />
        </button>
        {/* <a href="#" className="btn btn-primary w-md">
                    Send
                  </a> */}
      </div>
    </div>
  );
});

export default InvoiceComponent;
